class BESSAppProjectSidebarToggle {

    _cookieName = 'BESSAppProjectSidebarToggle';

    constructor(sidebar) {
        this.sidebar = sidebar;
        this.main = $('.main');
        this.toggleTarget = $('body');
        this.toggle = $('.app-sidebar-toggle');
        this.toggle.bindClickEvent(this, this.#onToggle);

    }

    #onToggle() {
        this.sidebar.node.addClass('animate');
        this.main.addClass('animate');
        this.toggleTarget.toggleClass('sidebar-hide');
        setTimeout(function(){
            this.sidebar.node.removeClass('animate');
            this.main.removeClass('animate');
        }.bind(this), 500);

        let collapsed = this.toggleTarget.hasClass('sidebar-hide');
        BESSApp.instance.services.api.session.apiUpdateSidebar(collapsed, () => {});
    }
}